import { useElementsScoreSettings } from 'reducers/reviewCreationSlice';

export const GOAL_ASPECTS = [{ name: 'Key Results' }, { name: 'Objectives' }, { name: 'Objectives and Key Results' }];

const useGoalAspect = ({ feedbackFormId }) => {
  const { isIncludeObjectives, isIncludeGoals } = useElementsScoreSettings({ feedbackFormId });

  if (isIncludeObjectives && isIncludeGoals) {
    return {
      index: 2,
      label: GOAL_ASPECTS[2].name,
    };
  }
  if (isIncludeObjectives) {
    return {
      index: 1,
      label: GOAL_ASPECTS[1].name,
    };
  }
  return {
    index: 0,
    label: GOAL_ASPECTS[0].name,
  };
};

export default useGoalAspect;
